import { DataFilters } from './data-filters.service';

export class DataUtils {
  public static getWorldName(
    dataFilters: DataFilters,
    worldName: string,
    forceGlobalName = false
  ): string {
    if (dataFilters.regionSelection.isCitySelected() && !forceGlobalName) {
      return [...dataFilters.regionSelection.countries.values()][0].name;
    }
    if (
      dataFilters.dataLens &&
      dataFilters.regionSelection.countries.size === 1
    ) {
      // In subnational view, the world becomes the subnational country
      return [...dataFilters.regionSelection.countries.values()][0].name;
    } else {
      return worldName;
    }
  }
}
